export default {
  title: "",
  content: [
    "You’re going to need to provide a number of documents during the home study process. You can turn these things in all at once or over the course of your required trainings.",
    "I highly recommend making a digital copy of anything you turn in.",
    "Here’s a list of the documents I was required to turn in.",
    "It really wow’d our licensing worker when we had everything except the physicals prepared and in a big pile to be turned in when she came for the first home visit.",
  ],
};
